import { createFeatureSelector, createSelector } from '@ngrx/store';
import { portfolioAdapter, PortfolioState } from './portfolio.reducer';
import * as PortfolioReducer from './portfolio.reducer';

export const getPortfolioState =
  createFeatureSelector<PortfolioState>('portfolio');

export const {
  selectAll: getAllPortfolio,
  selectEntities: getPortfolioEntities,
  selectIds: getPortfolioIds,
  selectTotal: getTotalPortfolio,
} = portfolioAdapter.getSelectors(getPortfolioState);

export const getSelectedPortfolioId = createSelector(
  getPortfolioState,
  (state: PortfolioState) => state.selectedPortfolioId
);

// export const getSelectedPortfolio = createSelector(
//   getPortfolioEntities,
//   getSelectedPortfolioId,
//   (entities, id) => (id ? entities[id] : null)
// );

export const getCurrentPage = createSelector(
  getPortfolioState,
  (state: PortfolioState) => state.currentPage
);

export const getTotalPages = createSelector(
  getPortfolioState,
  (state: PortfolioState) => state.totalPages
);

export const getTotalItems = createSelector(
  getPortfolioState,
  (state: PortfolioState) => state.totalItems
);

export const getLoading = createSelector(
  getPortfolioState,
  (state: PortfolioState) => state.loading
);
export const selectAllPortfolio = createSelector(
  getPortfolioState,
  PortfolioReducer.selectAllPortfolio
);

export const getSelectedPortfolio = createSelector(
  getPortfolioState,
  (state: PortfolioState) => state.selectedPortfolio
);
